var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from 'ethers';
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'baseURI_',
                type: 'string',
            },
            {
                internalType: 'uint128',
                name: 'maxSupply_',
                type: 'uint128',
            },
            {
                internalType: 'uint256',
                name: 'launchTimestamp_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'auctionEndTimestamp_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'startingPricePerTokenMint_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'auctionStages_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'physicalPrice_',
                type: 'uint256',
            },
            {
                internalType: 'uint128',
                name: 'specialsTarget_',
                type: 'uint128',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approved',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'assetGeneratorHash',
                type: 'bytes32',
            },
        ],
        name: 'AssetGeneratorHashSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'baseURI',
                type: 'string',
            },
        ],
        name: 'BaseURISet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'enum IStencils.BuyerType',
                name: 'buyerType',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint128',
                name: 'promotionalQuantity',
                type: 'uint128',
            },
        ],
        name: 'BuyerSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'OwnershipAccepted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipProposed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'startingPrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'auctionStages',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'physicalPrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'specialsTarget',
                type: 'uint256',
            },
        ],
        name: 'ParametersSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
        ],
        name: 'PhysicalCopyClaimed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'ProceedsDestinationSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'destination',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'ProceedsWithdrawn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        inputs: [],
        name: 'AUCTION_END_TIMESTAMP',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'LAUNCH_TIMESTAMP',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MAX_SUPPLY',
        outputs: [
            {
                internalType: 'uint128',
                name: '',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'acceptOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'assetGeneratorHash',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'auctionStages',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'availableSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: 'availableSupply_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'baseURI',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'buyerInfoFor',
        outputs: [
            {
                internalType: 'enum IStencils.BuyerType',
                name: 'buyerType',
                type: 'uint8',
            },
            {
                internalType: 'uint128',
                name: 'quantity',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'destination_',
                type: 'address',
            },
            {
                internalType: 'uint128',
                name: 'quantity_',
                type: 'uint128',
            },
            {
                internalType: 'uint128',
                name: 'minQuantity_',
                type: 'uint128',
            },
        ],
        name: 'claim',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'tokenIds_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'contractURI',
        outputs: [
            {
                internalType: 'string',
                name: 'contractURI_',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'currentAuctionStage',
        outputs: [
            {
                internalType: 'uint256',
                name: 'auctionStage_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'getApproved',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'buyer_',
                type: 'address',
            },
        ],
        name: 'getPurchaseInformationFor',
        outputs: [
            {
                internalType: 'bool',
                name: 'canClaim_',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'claimableQuantity_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'price_',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'physicalCopyIncluded_',
                type: 'bool',
            },
            {
                internalType: 'bool',
                name: 'specialIncluded_',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'auctionStage_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'timeRemaining_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'destinations_',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts_',
                type: 'uint256[]',
            },
            {
                internalType: 'bool[]',
                name: 'physicals_',
                type: 'bool[]',
            },
        ],
        name: 'give',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isLive',
        outputs: [
            {
                internalType: 'bool',
                name: 'isLive_',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isPriceStatic',
        outputs: [
            {
                internalType: 'bool',
                name: 'priceIsStatic_',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'ownerOf',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pendingOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'physicalCopyRecipient',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'physicalPrice',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pricePerTokenMint',
        outputs: [
            {
                internalType: 'uint256',
                name: 'pricePerTokenMint_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'proceedsDestination',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner_',
                type: 'address',
            },
        ],
        name: 'proposeOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'destination_',
                type: 'address',
            },
            {
                internalType: 'uint128',
                name: 'quantity_',
                type: 'uint128',
            },
            {
                internalType: 'uint128',
                name: 'minQuantity_',
                type: 'uint128',
            },
        ],
        name: 'purchase',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'tokenIds_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId_',
                type: 'uint256',
            },
        ],
        name: 'purchasePhysical',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account_',
                type: 'address',
            },
        ],
        name: 'reseedInfoFor',
        outputs: [
            {
                internalType: 'uint8',
                name: 'count_',
                type: 'uint8',
            },
            {
                internalType: 'uint32[7]',
                name: 'seeds_',
                type: 'uint32[7]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'assetGeneratorHash_',
                type: 'bytes32',
            },
        ],
        name: 'setAssetGeneratorHash',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'baseURI_',
                type: 'string',
            },
        ],
        name: 'setBaseURI',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts_',
                type: 'address[]',
            },
            {
                internalType: 'enum IStencils.BuyerType[]',
                name: 'buyerTypes_',
                type: 'uint8[]',
            },
            {
                internalType: 'uint128[]',
                name: 'quantities_',
                type: 'uint128[]',
            },
        ],
        name: 'setBuyerInfos',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'startingPricePerTokenMint_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'auctionStages_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'physicalPrice_',
                type: 'uint256',
            },
            {
                internalType: 'uint128',
                name: 'specialsTarget_',
                type: 'uint128',
            },
        ],
        name: 'setParameters',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'proceedsDestination_',
                type: 'address',
            },
        ],
        name: 'setProceedsDestination',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts_',
                type: 'address[]',
            },
            {
                internalType: 'uint8[]',
                name: 'counts_',
                type: 'uint8[]',
            },
            {
                internalType: 'uint32[7][]',
                name: 'seeds_',
                type: 'uint32[7][]',
            },
        ],
        name: 'setReseeds',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'specialCount',
        outputs: [
            {
                internalType: 'uint128',
                name: '',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'specialsTarget',
        outputs: [
            {
                internalType: 'uint128',
                name: '',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'startingPricePerTokenMint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeToLaunch',
        outputs: [
            {
                internalType: 'uint256',
                name: 'timeToLaunch_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId_',
                type: 'uint256',
            },
        ],
        name: 'tokenURI',
        outputs: [
            {
                internalType: 'string',
                name: 'tokenURI_',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner_',
                type: 'address',
            },
        ],
        name: 'tokensOfOwner',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'tokenIds_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawProceeds',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
var isSuperArgs = function (xs) { return xs.length > 1; };
var Stencils__factory = /** @class */ (function (_super) {
    __extends(Stencils__factory, _super);
    function Stencils__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        _this.contractName = 'Stencils';
        return _this;
    }
    Stencils__factory.prototype.deploy = function (baseURI_, maxSupply_, launchTimestamp_, auctionEndTimestamp_, startingPricePerTokenMint_, auctionStages_, physicalPrice_, specialsTarget_, overrides) {
        return _super.prototype.deploy.call(this, baseURI_, maxSupply_, launchTimestamp_, auctionEndTimestamp_, startingPricePerTokenMint_, auctionStages_, physicalPrice_, specialsTarget_, overrides || {});
    };
    Stencils__factory.prototype.getDeployTransaction = function (baseURI_, maxSupply_, launchTimestamp_, auctionEndTimestamp_, startingPricePerTokenMint_, auctionStages_, physicalPrice_, specialsTarget_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, baseURI_, maxSupply_, launchTimestamp_, auctionEndTimestamp_, startingPricePerTokenMint_, auctionStages_, physicalPrice_, specialsTarget_, overrides || {});
    };
    Stencils__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Stencils__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Stencils__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    Stencils__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    Stencils__factory.bytecode = _bytecode;
    Stencils__factory.abi = _abi;
    return Stencils__factory;
}(ContractFactory));
export { Stencils__factory };
//# sourceMappingURL=Stencils__factory.js.map